import Vue from 'vue'
import Vuex from 'vuex'

import fakeLayers from '../fake/layers'
import fakeMaps from '../fake/maps'
import fakeMapPlants from '../fake/maps_plants'
import fakePlants from '../fake/plants'
import Plant from '@/classes/Plant'
import MapPlant from '@/classes/MapPlant'
import MapConfig from '@/classes/MapConfig'
import PlantationLayer from '@/classes/PlantationLayer'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layers: [],
    mapPlants: [],
    maps: [],
    plants: [],
    currentMap: null,
  },
  mutations: {
    // Layers
    setLayers (state, layers) { state.layers = layers },

    // Maps
    setMaps (state, maps) { state.maps = maps },
    addMap (state, theMap) { state.maps.push(theMap) },

    // MapPlants
    setMapPlants (state, plants) { state.mapPlants = plants },
    addMapPlant (state, plant) { state.mapPlants.push(plant) },
    updateMapPlant (state, newValue) {
      const index = state.mapPlants.findIndex((e) => e.id === newValue.id)
      if (index === -1) throw new Error(`updateMapPlant: Can't update ${newValue.id}`)

      state.mapPlants[index] = newValue
    },
    deleteMapPlant (state, id) {
      const index = state.mapPlants.findIndex((e) => e.id === id)
      if (index === -1) return

      state.mapPlants.splice(index, 1)
    },

    // Plants
    setPlants (state, plants) { state.plants = plants },

    // Current map
    setCurrentMap (state, value) { state.currentMap = value },
  },
  actions: {
    // Layers
    loadLayers: ({ commit }) => {
      return fakeLayers.load()
        .then((plantationLayers) => {
          plantationLayers = plantationLayers.map(p => new PlantationLayer(p))
          commit('setLayers', plantationLayers)
          return Promise.resolve(plantationLayers)
        })
        .catch((e) => { console.error('loadLayers:', e) })
    },

    // Maps
    loadMaps: ({ commit }) => {
      return fakeMaps.load()
        .then((maps) => {
          maps = maps.map(m => new MapConfig(m))
          commit('setMaps', maps)
          return Promise.resolve(maps)
        })
        .catch((e) => { console.error('loadMaps:', e) })
    },
    addMap: ({ commit }, payload) => {
      return fakeMaps.add(payload)
        .then((theMap) => {
          theMap = new MapConfig(theMap)
          commit('addMap', theMap)
          return Promise.resolve(theMap)
        })
        .catch((e) => { console.error('addMap:', e) })
    },

    // MapPlants
    loadMapPlants: ({ commit }) => {
      return fakeMapPlants.load()
        .then((mapPlants) => {
          mapPlants = mapPlants.map((m) => new MapPlant(m))
          commit('setMapPlants', mapPlants)
          return Promise.resolve(mapPlants)
        })
        .catch((e) => { console.error('loadMapPlants:', e) })
    },
    addMapPlant: ({ commit }, payload) => {
      return fakeMapPlants.add(payload)
        .then((mapPlant) => {
          mapPlant = new MapPlant(mapPlant)
          commit('addMapPlant', mapPlant)
          return Promise.resolve(mapPlant)
        })
        .catch((e) => { console.error('addMapPlant:', e) })
    },
    updateMapPlant: ({ commit }, payload) => {
      return fakeMapPlants.update(payload)
        .then((mapPlant) => {
          mapPlant = new MapPlant(mapPlant)
          commit('updateMapPlant', mapPlant)
          return Promise.resolve(mapPlant)
        })
        .catch((e) => { console.error('updateMapPlant:', e) })
    },
    deleteMapPlant: ({ commit }, id) => {
      return fakeMapPlants.delete(id)
        .then((id) => {
          commit('deleteMapPlant', id)
          return Promise.resolve(id)
        })
        .catch((e) => { console.error('deleteMapPlant:', e) })
    },

    // Plants
    loadPlants: ({ commit }) => {
      return fakePlants.load()
        .then((plants) => {
          plants = plants.map(p => new Plant(p))
          commit('setPlants', plants)
          return Promise.resolve(plants)
        })
        .catch((e) => { console.error('loadPlants:', e) })
    },

    // Current map
    setCurrentMap: ({ commit }, value) => { commit('setCurrentMap', value) },
  },
  getters: {
    // Layers
    layers: state => state.layers,
    layer: state => id => state.layers.find(l => l.id === id),
    // Maps
    maps: state => state.maps,
    map: state => id => state.maps.find(m => m.id === id),
    // MapPlants
    mapPlants: state => state.mapPlants,
    mapPlantsByIds: state => ids => state.mapPlants.filter(p => ids.indexOf(p.id) > -1),
    // Plants
    plants: state => state.plants,
    plant: state => id => state.plants.find(p => p.id === id),
    // Current map
    currentMap: state => state.currentMap,
  },
})
